import {cx} from "emotion";
import * as React from "react";

import "./progress-numbering.scss";

import {createArray} from "@Common/utils/collections";

export const ProgressNumbering = ({index, total, limit=5, onChange}) => {
    const offset = Math.max(0, index - limit + 1);

    return (
        <div className="progress-numbering progress-numbering-3dj">
            <i
                className="nav fa fa-chevron-left"
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (index == null || index === 0) {
                        onChange(total - 1);
                    } else {
                        onChange(index - 1);
                    }
                }}
                xd-qa-type="icon"
                xd-qa-name="arrow_left"
            />

            {createArray(Math.min(limit, total)).map((i) => (
                <div
                    className={cx("dot", {active: index === i + offset})}
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        onChange(i + offset);
                    }}
                    key={i}
                    xd-qa-type="icon"
                    xd-qa-name="dot"
                >
                </div>
            ))}

            <i
                className="nav fa fa-chevron-right"
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (index === total - 1) {
                        onChange(0);
                    } else {
                        onChange((index || 0) + 1);
                    }
                }}
                xd-qa-type="icon"
                xd-qa-name="arrow_right"
            />
        </div>
    );
};
